import LogoComponent from './logo.component'

export default LogoComponent
